// ------------------------------------------------------------
// UI
//
// TBD
// ------------------------------------------------------------

import NProgress from 'nprogress';
import moment from 'moment';
import isDate from 'lodash/isDate';
import isNumber from 'lodash/isNumber';
import numeral from 'numeral';
import PACONST from '@/support/constants';

NProgress.configure({
  minimum: 0.20,
  trickleSpeed: 100,
  showSpinner: false
});

function format (value, formatType) {
  let formattedValue = null;
  if (value !== undefined && value !== null) {
    switch (formatType) {
      case PACONST.DISPLAY_TYPE_DATE:
        if (isDate(value) || moment(value).isValid()) {
          formattedValue = moment(value).format('L');
        }
        break;
      case PACONST.DISPLAY_TYPE_DATETIME:
        if (isDate(value) || moment(value).isValid()) {
          formattedValue = moment(value).format('L') + ' ' + moment(value).format('LT');
        }
        break;
      case PACONST.DISPLAY_TYPE_DECIMAL:
        if (isNumber(value)) {
          formattedValue = numeral(value).format('0,0.00');
        }
        break;
      case PACONST.DISPLAY_TYPE_MONEY:
        if (isNumber(value)) {
          formattedValue = numeral(value).format('$0,0.00');
        }
        break;
      case PACONST.DISPLAY_TYPE_NUMBER:
        if (isNumber(value)) {
          formattedValue = numeral(value).format('0,0');
        }
        break;
      case PACONST.DISPLAY_TYPE_PERCENT:
        if (isNumber(value)) {
          formattedValue = numeral(value).format('0%');
        }
        break;
      default:
        throw new Error('ERROR - invalid format type [' + formatType + ']');
    }
  }

  return formattedValue;
}

function getHeaderAlignmentClass (dataType)
{
  let styleClass = '';
  switch (dataType)
  {
    case PACONST.DISPLAY_TYPE_BOOLEAN:
      styleClass = 'text-xs-center';
      break;

    case PACONST.DISPLAY_TYPE_MONEY:
    case PACONST.DISPLAY_TYPE_NUMBER:
    case PACONST.DISPLAY_TYPE_DECIMAL:
    case PACONST.DISPLAY_TYPE_PERCENT:
      styleClass = 'text-xs-right';
      break;

    default:
      styleClass = 'text-xs-left';
      break;
  }

  return styleClass;
}

export
{
  format,
  getHeaderAlignmentClass
};
